<template>
  <el-form
    :model="form"
    ref="form"
    @submit.native.prevent
    class="multiline-input"
  >
    <el-form-item
      v-for="(item, i) in form.list"
      :key="item.id"
      :label="field.lbl"
      :prop="'list.' + i + '.value'"
      :rules="rules"
      class="multiline-input__item"
    >
      <div class="multiline-input__item--content">
        <Dropdown
          v-if="selectType(field.type)"
          :options="options"
          :field="field"
          :model="item.name"
          visibleLoadMoreBtn
          @change-option="(name, id_name, opt) => updateOption(i, opt)"
          @filter-option="loadOptions"
          @load-more="loadMoreOptions"
        />
        <Input
          v-else
          :field="field"
          :model="item.value"
          @set-value="(field, value) => updateItem(i, value)"
        />
        <Button
          class="multiline-input__item--delete-btn"
          buttonSize="small"
          hasLeftIcon
          iconName="delete-trash"
          iconColor="#62717E"
          buttonColor="transparent"
          @click="removeItem(i)"
        />
      </div>
    </el-form-item>
    <Button
      class="multiline-input__add-btn"
      buttonText="Добавить ещё"
      buttonSize="big"
      @click="appendItem"
    />
  </el-form>
</template>
<script>
import Input from 'Elements/Input/Input.vue';
import Dropdown from 'Elements/Select/Dropdown.vue';
import Button from 'Elements/Button/Button';
import { Form, FormItem } from 'element-ui';
import { form } from '@/utils/mixins';
export default {
  mixins: [form],
  props: {
    field: {
      type: Object
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      form: {
        list: [],
      },
      lastId: 0
    };
  },
  created() {
    this.appendItem();
  },
  methods: {
    updateItem(index, value) {
      const newList = [...this.form.list];
      newList[index].value = value;
      this.$emit('input', newList);
    },
    updateOption(index, opt) {
      const newList = [...this.form.list];
      newList[index].value = opt.id;
      newList[index].name = opt.name
      this.$emit('input', newList);
    },
    appendItem() {
      const newItem = {
        id: this.lastId++,
        value: ''
      }
      const newList = [...this.form.list, newItem];
      this.$emit('input', newList);
    },
    removeItem(index) {
      const newList = [...this.form.list];
      newList.splice(index, 1);
      this.$emit('input', newList);
    },
    loadOptions(searchString) {
      this.$emit('load-options', this.field.paginationUrl, searchString, false);
    },
    loadMoreOptions(searchString) {
      this.$emit('load-options', this.field.paginationUrl, searchString, true);
    },
    async isValid() {
      const form = this.$refs['form'];
      return new Promise((resolve) => {
        form.validate((valid) => resolve(valid))
      })
    }
  },
  watch: {
    value(newList) {
      this.form.list = newList;
    }
  },
  components: {
    Input,
    Dropdown,
    Button,
    'el-form': Form,
    'el-form-item': FormItem
  }
};
</script>
<style lang="scss" scoped>
.multiline-input {
  &__item {
    height: 88px;

    &--content {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    &--delete-btn {
      height: 24px;
      width: 24px;
    }
  }

  &__add-btn {
    width: 100%;
  }
}
</style>
